import { InfiniteQueryPageContext, PaginatedResponseModel, useHTTP, useHTTPQueryWithCursor } from "shared/lib/http";
import { useUserAuthState } from "src/features/auth/UserAuthState";
import { API_BASE_URL } from "src/lib/config";

export interface ListTcbClaimReportsResponseModel {
	readonly name: string;
}

export const useTcbClaimReports = () => {
	const { state } = useUserAuthState();
	const http = useHTTP(state.accessToken);

	return useHTTPQueryWithCursor(["tcbClaimReports"], ({ pageParam = 0 }: InfiniteQueryPageContext) => {
		return http<PaginatedResponseModel<ListTcbClaimReportsResponseModel>>({
			method: "GET",
			url: `${API_BASE_URL}/admin/tcb-claim-report?cursor=${pageParam}`
		});
	});
};
